import mercadoImg from '../img/mercado.jpg';
import medicinasImg from '../img/medicinas.jpg';
import educacionImg from '../img/educacion.jpg';

export const couponBenefits = [
  {
    id: 'MERCADO',
    thumbnail: mercadoImg,
    name: 'Bono de mercado',
    benefitType: 'COUPON',
    category: 'mercado',
    photos: [],
  },
  {
    id: 'MEDICINAS',
    thumbnail: medicinasImg,
    name: 'Bono de medicamentos',
    benefitType: 'COUPON',
    category: 'medicinas',
    photos: [],
  },
  {
    id: 'EDUCACION',
    thumbnail: educacionImg,
    name: 'Bono de educación',
    benefitType: 'COUPON',
    category: 'educacion',
    photos: [],
  },
];
